import { useParams } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { useMutation } from '@apollo/client';
import { CREATE_PAYMENT_SESSION } from '~/services/payments';
import moment from 'moment';

const Subscription: React.FC<any> = ({ paymentConfig }) => {
  const { agentId } = useParams();
  const { i18n } = useTranslation();
  const [t] = useTranslation('payments');
  const [createPaymentSession, { loading }] = useMutation(
    CREATE_PAYMENT_SESSION,
  );

  // Get renewal date from various sources (paid subscription or demo subscription)
  const renewalDate =
    paymentConfig?.agentSubscription?.cutoffDate ||
    paymentConfig?.subscriptionData?.active?.period_end
      ? moment(
          paymentConfig?.agentSubscription?.cutoffDate ||
            paymentConfig?.subscriptionData?.active?.period_end,
        )
          .locale(i18n.language)
          .format('D MMMM YYYY')
      : null;

  // Subscribe handler
  const handleSubscribe = async (product: any) => {
    try {
      const { data } = await createPaymentSession({
        variables: {
          data: {
            agent_id: agentId,
            product_id: product.id,
          },
        },
      });
      const url = data?.create_payment_session?.data?.url;
      if (url) {
        window.location.href = url;
      } else {
        alert(
          t(
            'error_creating_payment_session',
            'Could not create payment session.',
          ),
        );
      }
    } catch (err) {
      alert(
        t(
          'error_creating_payment_session',
          'Could not create payment session.',
        ),
      );
    }
  };

  return (
    <div className="flex max-w-[700px] flex-col gap-4">
      <p>
        <Trans
          i18nKey="description_subscription_options"
          ns="payments"
          components={{ bold: <span className="font-bold" /> }}
        />
      </p>
      {renewalDate && (
        <div className="stats mb-6 shadow">
          <div className="stat">
            <div className="stat-title">
              {t('next_renewal', 'Next Renewal')}
            </div>
            <div className="stat-value">{renewalDate}</div>
          </div>
        </div>
      )}
      <div className="mt-8 flex w-full flex-wrap justify-center gap-4 md:justify-between">
        {(paymentConfig.products || [])
          .slice()
          .sort((a: any, b: any) => {
            const aPrice = a.price?.unit_amount ?? Infinity;
            const bPrice = b.price?.unit_amount ?? Infinity;
            return aPrice - bPrice;
          })
          .map((product: any, idx: number) => {
            const price = product.price?.unit_amount
              ? product.price.unit_amount / 100
              : '-';
            const messages =
              product.metadata?.messages ||
              product.metadata?.['messages '] ||
              product.description ||
              '';
            return (
              <div
                key={product.id}
                className="border-base-300 bg-base-100 flex min-w-[220px] max-w-[260px] flex-grow flex-col items-center rounded-lg border p-6 shadow transition-shadow hover:shadow-lg"
                style={{ flexBasis: '220px' }}
              >
                <div className="text-primary mb-2 text-2xl font-bold">
                  {product.name}
                </div>
                <div className="text-md mb-2 text-center font-semibold">
                  {messages && t('messages_included', { count: messages })}
                </div>
                <div className=" mb-4 text-3xl font-bold">
                  {price !== '-' ? `$${price}` : t('no_price', 'No price')}
                  <span className="ml-1 text-base font-normal text-gray-500">
                    /mo
                  </span>
                </div>
                <button
                  className="btn btn-primary mt-auto w-full rounded-full"
                  onClick={() => handleSubscribe(product)}
                  disabled={loading}
                >
                  {loading
                    ? t('loading', 'Loading...')
                    : t('subscribe_button', 'Subscribe')}
                </button>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default Subscription;
